import { Button, Intent } from "@blueprintjs/core" 
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { useState } from "react"
import { Bookmark, CommentInputForm, Likes, MediaChooser, showToast, ConfirmButton} from "src/libs/useful"
import AvatarLink from "src/libs/useful/AvatarLink"
import Select from "src/libs/useful/select"
import postMock from "src/libs/.test/post.mock"
import usersMock from "src/libs/.test/users.mock"

const LABEL_NAME = "confirm label name"
const DIALOG_TITLE = "confirm dialog title"
const YES_LABEL = "confirm yes"
const NO_LABEL = "confirm no"

const LocalWorksForm = (props:any) :JSX.Element => {
    const[value, setValue] = useState("/assets/img/PE_logo_large.svg")
    const[selectValue, setSelectValue] = useState({
        id:2,
        title: "Второй",
    })
    const onChange = (value: any) => {
        setSelectValue(value)
    }
    const onSend = () => {
        
    }
    const onBookmark = () => {
        
    }
    const onSelect = (value: any) => {
        console.log( value)
    }
    const onAppToaster = async () => {
        showToast({
            message:"AAAA",
            intent: Intent.SUCCESS,
            className: "p-4 lead-md",
            timeout: 4000
        })
    }
    return (
        <div className="layout-app-state flex-centered flex-column">
            <div className="container position-relative" style={{minHeight:330}}>
                <MediaChooser 
                    height={160}
                    padding={0}
                    id={"media-chooser-1"}
                    url={value}
                    onChange={onChange}
                />
            </div>
            <div className="container my-4" >
                
            </div>
            <div className="container" >
                <Button onClick={onAppToaster}>AppToaster</Button>
            </div> 
            <div className="container" >
                <CommentInputForm
                    className=""
                    item={ postMock() } 
                    autoFocus
                    onSend={onSend} 
                /> 
            </div> 
            <div className="container">
                <div className="row">
                    <div className="col-6 my-2">
                        <ConfirmButton
                            buttonMinimal
                            onConfirm={onSend}
                            buttonLabel={LABEL_NAME}
                            dialogClasssName={DIALOG_SIZE.MINIMAL}
                            dialogTitle={DIALOG_TITLE}
                            yesLabel={YES_LABEL}
                            noLabel={NO_LABEL}
                        >
                            <div data-testid="confirm-content" className="p-5"/>
                        </ConfirmButton>
                    </div>
                    <div className="col-6">
                        <Select
                            items={[
                                {
                                    id:1,
                                    title: "Первый",
                                },
                                {
                                    id:2,
                                    title: "Второй",
                                },
                                {
                                    id:3,
                                    title: "Третий",
                                },
                                {
                                    id:4,
                                    title: "Четвертый",
                                },
                            ]}
                            value={selectValue}
                            onChange={onSelect}
                        />
                    </div>
                    <div className="col-6 flex-centered ">
                        <Likes
                            item={ postMock() } 
                            dataType='PEFestProject'
                        />
                        <Bookmark
                            item={ postMock() } 
                            onBookmark={onBookmark}
                        />
                    </div>
                    <div className="col-6 ">
                        <AvatarLink
                            user={ usersMock()[0]}
                            selected={ usersMock()[0] }  
                        />
                    </div>
                </div>
                
            </div>
        </div>
    )
} 

export default LocalWorksForm